import { Tooltip as MUITooltip, useMediaQuery, useTheme } from "@mui/material";

const SATruncateWithEllipsis = ({
  text,
  maxLength, // optional base value
  placement = "top",
  showDash = true,
  ...rest
}) => {
  const theme = useTheme();

  // Define breakpoints for responsiveness
  const isXs = useMediaQuery(theme.breakpoints.down("sm")); // mobile
  const isSm = useMediaQuery(theme.breakpoints.between("sm", "md")); // tablet
  const isMd = useMediaQuery(theme.breakpoints.between("md", "lg")); // small laptop
  const isLg = useMediaQuery(theme.breakpoints.up("lg")); // large screens

  // Dynamically adjust truncation based on screen size

  const defaultBase = 20;
  let responsiveMaxLength;

  if (typeof maxLength === "number") {
    if (isXs || isSm) {
      // mobile & tablet: use the maxLength exactly as provided
      responsiveMaxLength = maxLength;
    } else if (isMd) {
      // small laptop: keep a slight scaling if desired
      responsiveMaxLength = Math.max(3, Math.floor(maxLength * 0.8));
    } else if (isLg) {
      responsiveMaxLength = maxLength;
    } else {
      responsiveMaxLength = maxLength;
    }
  } else {
    // no maxLength provided -> fall back to previous defaults per breakpoint
    if (isXs) responsiveMaxLength = 20;
    else if (isSm) responsiveMaxLength = 22;
    else if (isMd) responsiveMaxLength = 25;
    else if (isLg) responsiveMaxLength = defaultBase || 30;
    else responsiveMaxLength = defaultBase;
  }

  if (!text) return showDash ? "-" : "";

  if (text.length <= responsiveMaxLength) {
    return text;
  }

  const truncatedText = text.slice(0, Math.max(0, responsiveMaxLength - 3));

  return (
    <MUITooltip title={text} arrow placement={placement} {...rest}>
      <span>{`${truncatedText}...`}</span>
    </MUITooltip>
  );
};

export default SATruncateWithEllipsis;
